import { useState } from 'react';
import SAR from '@/components/feature/SAR';
import { monthlyData } from '@/mocks/dashboard';

const DashboardChart = () => {
  const [view, setView] = useState<'amount' | 'donors'>('amount');

  const maxAmount = Math.max(...monthlyData.map((d) => d.amount));
  const maxDonors = Math.max(...monthlyData.map((d) => d.donors));

  const fmt = (n: number) =>
    new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(n);

  const totalAmount = monthlyData.reduce((s, d) => s + d.amount, 0);
  const totalDonors = monthlyData.reduce((s, d) => s + d.donors, 0);

  return (
    <div className="bg-white rounded-2xl border border-stone-100 p-5">
      {/* Header */}
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-black text-stone-800 text-base">نمو الحملة</h3>
        <div className="flex gap-1 bg-stone-100 rounded-xl p-1">
          <button
            onClick={() => setView('amount')}
            className={`px-3 py-1 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
              view === 'amount' ? 'bg-white text-stone-800 shadow-sm' : 'text-stone-500'
            }`}
          >
            المبالغ
          </button>
          <button
            onClick={() => setView('donors')}
            className={`px-3 py-1 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-nowrap ${
              view === 'donors' ? 'bg-white text-stone-800 shadow-sm' : 'text-stone-500'
            }`}
          >
            الداعمون
          </button>
        </div>
      </div>

      {/* Summary */}
      <div className="flex gap-4 mb-5">
        <div>
          <p className="text-xs text-stone-400">إجمالي 6 أشهر</p>
          <p className="text-lg font-black text-stone-800">
            {view === 'amount' ? <SAR amount={totalAmount} iconSize={14} /> : `${fmt(totalDonors)} داعم`}
          </p>
        </div>
        <div className="flex items-center gap-1 text-emerald-600 text-xs font-semibold">
          <i className="ri-arrow-up-line"></i>
          <span>+62% نمو</span>
        </div>
      </div>

      {/* Bar Chart */}
      <div className="flex items-end gap-2 h-32">
        {monthlyData.map((d, i) => {
          const val = view === 'amount' ? d.amount : d.donors;
          const max = view === 'amount' ? maxAmount : maxDonors;
          const heightPct = (val / max) * 100;
          const isLast = i === monthlyData.length - 1;

          return (
            <div key={d.month} className="flex-1 flex flex-col items-center gap-1 group">
              <div className="relative w-full flex items-end justify-center" style={{ height: '100px' }}>
                {/* Tooltip */}
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-stone-800 text-white text-xs px-2 py-1 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                  {view === 'amount' ? <SAR amount={val} iconSize={11} /> : `${val} داعم`}
                </div>
                <div
                  className={`w-full rounded-t-lg transition-all duration-500 ${
                    isLast ? 'bg-emerald-500' : 'bg-emerald-200 group-hover:bg-emerald-300'
                  }`}
                  style={{ height: `${heightPct}%` }}
                />
              </div>
              <span className="text-xs text-stone-400 truncate w-full text-center">{d.month.slice(0, 3)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DashboardChart;
